import { ConcurrentExperience, ExperiencePerformanceTypes, ExperienceTypes } from '@atlaskit/ufo';
var inlineExperience = {
  platform: {
    component: 'smart-links'
  },
  type: ExperienceTypes.Experience,
  performanceType: ExperiencePerformanceTypes.InlineResult
};
var renderExperience = {
  platform: {
    component: 'smart-links'
  },
  type: ExperienceTypes.Load,
  performanceType: ExperiencePerformanceTypes.PageSegmentLoad
};
var aiExperience = {
  platform: {
    component: 'smart-links'
  },
  type: ExperienceTypes.Experience,
  performanceType: ExperiencePerformanceTypes.InlineResult
};
var ufoExperiences = {
  'smart-link-rendered': new ConcurrentExperience('smart-link-rendered', renderExperience),
  'smart-link-authenticated': new ConcurrentExperience('smart-link-authenticated', inlineExperience),
  'smart-link-action-invocation': new ConcurrentExperience('smart-link-action-invocation', inlineExperience),
  'smart-link-ai-summary': new ConcurrentExperience('smart-link-ai-summary', aiExperience)
};
export var startUfoExperience = function startUfoExperience(experienceName, id, properties) {
  var experience = ufoExperiences[experienceName].getInstance(id);
  experience.start();
  if (properties) {
    experience.addMetadata(properties);
  }
};
export var succeedUfoExperience = function succeedUfoExperience(experienceName, id, properties) {
  var experience = ufoExperiences[experienceName].getInstance(id);
  experience.success({
    metadata: properties
  });
};
export var failUfoExperience = function failUfoExperience(experienceName, id, properties) {
  var experience = ufoExperiences[experienceName].getInstance(id);
  experience.failure({
    metadata: properties
  });
};
export var addMetadataToExperience = function addMetadataToExperience(experienceName, id, properties) {
  ufoExperiences[experienceName].getInstance(id).addMetadata(properties);
};